import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/storage';

var firebaseConfig =
{
    apiKey: "AIzaSyAQEBlDjq-0hUwXeP-_V-_brw7bNxyqOYM",
    authDomain: "agile-shift-genesis.firebaseapp.com",
    databaseURL: "https://agile-shift-genesis.firebaseio.com",
    projectId: "agile-shift-genesis",
    storageBucket: "agile-shift-genesis.appspot.com",
    messagingSenderId: "632092524965",
    appId: "1:632092524965:web:db50b98dca95e39591a84c",
    measurementId: "G-1LNQZ7HEYE"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const fb = new Object();
fb.db = firebase.firestore();
fb.auth = firebase.auth();
fb.storage = firebase.storage();
fb.functions = firebase.app().functions('europe-west1');

console.log("* Firebase initialized");
export default fb;